<script>
import axios from "axios";

export default {
    methods: {
        setFiltersFromAddressbarUrl() {
            let pathName = window.location.pathname;
            pathName = pathName.replace('/inspiraties/', '');
            pathName = pathName.slice(0, -1); // remove trailing slash

            if (pathName) {
                let filtersFromAddressbarArray = pathName.split('/');
                let processed = 0;

                filtersFromAddressbarArray.forEach(value => {
                    let termUrl = window.location.origin;
                    termUrl += '/wp-admin/admin-ajax.php?action=term_id_slug&slug=';
                    termUrl += value;

                   if (!value.includes('page')) {
                       // console.log(taxUrl);
                       axios.get(termUrl).then(response => {
                           this.$store.commit('setFilterFromTermObject', response.data);
                           processed++;
                           if (filtersFromAddressbarArray.length === processed) {
                               this.allDone();
                           }
                       })
                           .catch(error => {
                               console.log(error);
                           });
                   } else {
                       // set page number
                       let lastChar = value.slice(-1);
                       lastChar = parseInt(lastChar)

                       if (!isNaN(lastChar)) {
                           this.$store.state.page = lastChar;
                       }

                       processed++;
                       if (filtersFromAddressbarArray.length === processed) {
                           this.allDone();
                       }
                   }

                });
            }

        },
        allDone() {
            console.log('allDone setFiltersFromAddressbarUrl()');
            this.$store.state.allFiltersSetFromUrl = true;
        }
    }
}
</script>